import config from "../app.json";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Context } from "../Reducers/Store";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import SideNav, { NavItem, NavIcon, NavText, Toggle } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import "./Styles/sidebar.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import UserAvatar from "../Assets/Images/avatar-sc.png";
import Image from "./Image/image";
import { Button } from "react-bootstrap";

import LogoURL from "../Assets/Svgs/logo.svg";
import ChatIcon from "../Assets/SvgComponents/ChatIcon";
import BankCardIcon from "../Assets/SvgComponents/BankCardIcon";
import SettingsIcon from "../Assets/SvgComponents/SettingsIcon";
import AlertComponent from "./AlertComponent";
import SidebarProfile from "./SidebarProfile/sidebarprofile";
import ChatListMenu from "./ChatListMenu/ChatListMenu";

const Sidebar = ({ expanded, setExpanded }) => {
  const [state, dispatch] = useContext(Context);
  const [itens, setItens] = useState([]);
  const [role, setRole] = useState([]);
  const [profile, setProfile] = useState({});
  const [hovered, setHovered] = useState(0);

  let navigate = useNavigate();
  let location = useLocation();

  const loadProfile = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    await axios
      .get(config.API_HM + "/profile")
      .then((result) => {
        setProfile(result.data);
        setRole(result.data.subscription.role);
      })
      .catch((error) => {
        AlertComponent("Error", error.message ?? "Something went wrong. Profile could not be loaded. Code: 1", { icon: `error` });
      })
      .finally(() => {
        dispatch({ type: "SET_LOADING", payload: false });
      });
  };
  useEffect(() => {
    loadChatList();
    if (state.isLogged) {
      loadProfile();
    }
  }, [state.isLogged]);

  useEffect(() => {
    if (state.profile) {
      loadProfile();
    }
  }, [state.profile]);

  useEffect(() => {
    if (state?.reloadchatlist) {
      loadChatList();
    }
  }, [state?.reloadchatlist]);

  const loadChatList = async () => {
    await axios
      .get(config.API_HM + "/chatlists")
      .then((resC) => {
        setItens(resC.data?.reverse());
        if (state?.reloadchatlist) {
          dispatch({ type: "SET_RELOAD_CHATLIST", payload: false });
        }
      })
      .catch(function (error) {
      });
  };

  const handleNavigate = (event, to) => {
    navigate(to, { replace: false });
    event.preventDefault();
  };

  const handleClick = ({ id }) => {
    return navigate(`/`, { state: { chatId: id } });
  };

  const handleShowConfig = () => {
    dispatch({ type: "SET_CONFIG", payload: !state?.config ?? false });
  };

  const handleShowNewChatlist = () => {
    dispatch({
      type: "SET_NEW_CHATLIST",
      payload: {
        newList: !state?.newlist ?? false,
        currentChatId: -1
      },
    });
  };

  const handleEditChatlist = (chatId) => {
    dispatch({
      type: "SET_NEW_CHATLIST",
      payload: {
        newList: !state?.newlist ?? false,
        currentChatId: chatId
      },
    });
  };

  const handleDeleteChatlist = (chatlistId) => {
    return AlertComponent(
      "Confirm",
      "Do you really want to delete the chatlist? This action cannot be undone.",
      { icon: `warning`, showConfirmButton: true, showCancelButton: true, cancelButtonText: "No" },
      () => confirmDeleteChatList(chatlistId),
      false,
      "Yes"
    );
  };

  const confirmDeleteChatList = async (chatlistId) => {
    await axios
      .delete(config.API_HM + "/chatlists/" + chatlistId)
      .then(() => {
        dispatch({ type: "SET_RELOAD_CHATLIST", payload: true });
      })
      .catch(function (error) {
        return AlertComponent("Error", error.message, { icon: `error` });
      });
  };

  const handleMouseEnter = (idParam) => {
    setHovered(idParam)
  }

  const handleMouseLeave = () => {
    setHovered(0);
  }

  return (
    <div>
      <SideNav
        className="left-menu"
        expanded={expanded}
        onToggle={setExpanded}
        style={{
          backgroundColor: "#151718",
          color: "#ff0",
          position: "fixed",
          width: 90,
          overflow: "hidden",
        }}>
        <SideNav.Toggle className={expanded ? `open-nav toggle-logo` : `closed-nav toggle-logo`} componentClass="div">
          {expanded && <Logo src={LogoURL} expanded={expanded} />}
        </SideNav.Toggle>
        <SideNav.Nav style={{ overflowY: "auto" }}>
          <NavItem active={location.pathname == "/" && !location?.state?.chatId} onClick={(e) => handleNavigate(e, "/")} className="menu-item">
            <NavIcon>
              <ChatIcon fill={"#9E9E9E"} />
            </NavIcon>
            <NavText>Chats</NavText>
          </NavItem>

          {/* <NavItem onClick={(e) => handleNavigate(e, "/search")}>
            <NavIcon>
              <SearchIcon fill={"#9E9E9E"} />
            </NavIcon>
            <NavText>Search</NavText>
          </NavItem> */}

          {role === "Owner" && (
            <NavItem active={location.pathname == "/selectplan"} onClick={(e) => handleNavigate(e, "/selectplan")}>
              <NavIcon>
                <BankCardIcon fill={"#9E9E9E"} />
              </NavIcon>
              <NavText>Manage subscription</NavText>
            </NavItem>
          )}

          {/* <NavItem active={location.pathname == "/faq"} onClick={(e) => handleNavigate(e, "/faq")}>
            <NavIcon>
              <BarCodeIcon fill={"#9E9E9E"} />
            </NavIcon>
            <NavText>Updates & FAQ</NavText>
          </NavItem> */}

          <NavItem onClick={(e) => handleShowConfig()}>
            <NavIcon>
              <SettingsIcon fill={"#9E9E9E"} />
            </NavIcon>
            <NavText>Settings</NavText>
          </NavItem>

          <div style={{ borderTop: "1px solid #ccc", margin: "10px 0" }}></div>

          {itens.map((x, index) => {
            return (
              <NavItem active={location?.state?.chatId == x.id} key={`menu_${index}`} onMouseEnter={() => handleMouseEnter(x.id)} onMouseLeave={handleMouseLeave}>
                <NavIcon
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }} onClick={() => handleClick(x)}>
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: x.color,
                      borderRadius: "5px",
                      display: "flex",
                    }}>
                    &nbsp;
                  </div>
                </NavIcon>
                <NavText style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignContent: "space-between", width: "100%" }} >
                  <span style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignContent: "space-between", flex: "1" }} onClick={() => handleClick(x)}>{x.name}</span>
                  <ChatListMenu chatId={x.id} handleEditChatlist={handleEditChatlist} handleDeleteChatlist={handleDeleteChatlist} isHovered={hovered} />
                  <span className="chat-counter" onClick={() => handleClick(x)}>{x.totalChats}</span>
                </NavText>
              </NavItem>
            );
          })}

          <NavItem onClick={(e) => handleShowNewChatlist()}>
            <NavIcon>
              <FontAwesomeIcon style={{ color: "#fff", fontSize: "20px", marginTop: 13 }} icon={faPlusCircle} />
            </NavIcon>
            <NavText style={{ color: "#37BB9C" }}>New List</NavText>
          </NavItem>

        </SideNav.Nav>
        <SideNav.Nav className="sidebar-profile-box" style={{ bottom: 0, width: "100%", position: "absolute", overflow: 'hidden' }}>
          <div>
            {expanded && profile?.subscription?.isTrialPeriod && <div className="free-badge-7">7 Day Trial</div>}
            <NavItem className="profile-item-sidebar">
              <NavIcon>
                
                <div className="profile">
                  <div className="top-profile">
                    <Image src={config.API_HM + "/profile/image/" + profile?.id} defaultSrc={UserAvatar} width={40} height={40} radius={20} />
                  </div>
                </div>
              </NavIcon>
              <NavText>
                {expanded && <SidebarProfile profile={profile} />}
              </NavText>
              {expanded && <Button className="settings-mini" size="sm" onClick={(e) => handleShowConfig()}></Button>}
            </NavItem>
          </div>
        </SideNav.Nav>
      </SideNav>
    </div>
  );
};

export default Sidebar;

const NavHeader = styled.div`
  display: ${(props) => (props.expanded ? "flex" : "none")};
  white-space: nowrap;
  align-items: center;
`;
const Logo = styled.img`
  width: auto;
  margin: 0 auto;
`;
